import * as React from 'react';
import { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../../../web/components-v2/Select';
import { styleSheet } from '../styles';

export interface IVerticalSelectOption {
	dataContext: string;
	id: string;
	text: string;
}

interface IProps {
	disabled?: boolean;
	onChange?: (item: IVerticalSelectOption) => void;
	options: IVerticalSelectOption[];
	selected?: string;
}

export const VerticalSelect: React.FC<IProps> = ({ disabled, onChange, options, selected }) => {
	const [selectedOption, selectOption] = useState<string>(selected || '');

	const onValueChange = (value: string) => {
		const option = options.find(x => x.dataContext === value);
		if (option) {
			onChange?.(option);
			selectOption(option.dataContext);
		}
	};

	return (
		<Select value={selectedOption} onValueChange={onValueChange} disabled={disabled}>
			<SelectTrigger styles={styleSheet.selectTrigger}>
				{options.find(x => x.dataContext === selectedOption)?.text ?? 'Select an option'}
			</SelectTrigger>
			<SelectContent styles={styleSheet.selectContent}>
				{options.map(option => (
					<SelectItem key={option.id} value={option.dataContext} styles={styleSheet.selectItem}>
						{option.text}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
